import { createContext, useContext } from "react";
import { Uid } from "../types";

export const UserIdContext = createContext<Uid>("");

export const useUserId = () => useContext(UserIdContext);
